import { Tag as AntTag } from "antd"
import type { TagProps } from "antd"

export const Tag = ({
  color,
  disabled,
  style,
  variant,
  ...props
}: TagProps) => {
  const primary = color === "primary" && !disabled
  const solid = variant === "solid"

  return (
    <AntTag
      {...props}
      color={color === "primary" ? undefined : color}
      disabled={disabled}
      variant={variant}
      style={
        primary
          ? {
              backgroundColor: solid
                ? "var(--ant-color-primary)"
                : "var(--ant-color-primary-bg)",
              borderColor:
                variant === "filled"
                  ? "transparent"
                  : solid
                    ? "var(--ant-color-primary)"
                    : "var(--ant-color-primary-border)",
              color: solid
                ? "var(--ant-color-text-light-solid)"
                : "var(--ant-color-primary)",
              ...style,
            }
          : style
      }
    />
  )
}
